import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.20.0_@parcel+watcher@2.5.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.22_db0@0.3.4_esli_mfn6ruyltul7hbkay32lah5rqm/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}